import { createFileRoute } from '@tanstack/react-router'
import { Play } from 'lucide-react'
import { z } from 'zod'
import { SimulationsScreen } from '@/screens/investigate/SCR-025-simulations'

export const Route = createFileRoute('/_app/w/$ws/simulations')({
  staticData: { screen: { id: 'SCR-025', title: 'Simulations', group: 'Investigate', perm: 'simulation.run', order: 11, description: 'Run a set of questions against a branch and against live memory to see what agents would get.', icon: Play } },
  validateSearch: z.object({ sim: z.string().max(200).optional() }),
  component: SimulationsScreen,
})
